import { MapPin, Phone, Mail, Car } from "lucide-react";
import { CAFE, HOURS, getCalgaryNow, isOpenNow } from "../data/cafeData";

export const LocationHours = () => {
  const open = isOpenNow();
  const today = getCalgaryNow().getDay();
  const orderedDays = [1, 2, 3, 4, 5, 6, 0];

  return (
    <section id="location" data-testid="location-section" className="bg-[#F5EFE6] py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-5 md:px-8">
        <p className="font-accent text-xs font-semibold uppercase tracking-[0.25em] text-[#C86D51]">
          Find Us
        </p>
        <h2 className="mt-4 font-serif text-2xl font-bold tracking-tight text-[#2C1D11] sm:text-3xl lg:text-4xl">
          Your corner of Royal Vista
        </h2>

        <div className="mt-12 grid gap-10 lg:grid-cols-2">
          <div className="space-y-8">
            <div className="rounded-3xl bg-[#FDFBF7] p-7 shadow-sm" data-testid="location-card">
              <div className="flex items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-[#C86D51]/15 text-[#C86D51]">
                  <MapPin size={19} />
                </span>
                <div>
                  <h3 className="font-accent text-base font-semibold text-[#2C1D11]">{CAFE.address}</h3>
                  <p className="text-sm text-[#6E5E53]">{CAFE.addressCity}</p>
                  <p className="mt-2 flex items-center gap-1.5 text-xs text-[#6E5E53]">
                    <Car size={13} /> Free parking in the plaza
                  </p>
                </div>
              </div>
              <div className="mt-6 flex flex-wrap gap-4 border-t border-[rgba(61,40,23,0.1)] pt-6">
                <a
                  href={CAFE.phoneHref}
                  data-testid="location-phone-link"
                  className="flex items-center gap-2 font-accent text-sm font-medium text-[#3D2817] transition-colors hover:text-[#C86D51]"
                >
                  <Phone size={15} className="text-[#C86D51]" /> {CAFE.phone}
                </a>
                <a
                  href={`mailto:${CAFE.email}`}
                  data-testid="location-email-link"
                  className="flex items-center gap-2 font-accent text-sm font-medium text-[#3D2817] transition-colors hover:text-[#C86D51]"
                >
                  <Mail size={15} className="text-[#C86D51]" /> {CAFE.email}
                </a>
              </div>
            </div>

            <div className="rounded-3xl bg-[#FDFBF7] p-7 shadow-sm" data-testid="hours-card">
              <div className="flex items-center justify-between">
                <h3 className="font-accent text-base font-semibold text-[#2C1D11]">Hours</h3>
                <span
                  data-testid="location-open-badge"
                  className={`rounded-full px-3 py-1 font-accent text-xs font-semibold ${
                    open ? "bg-[#6E7E65]/15 text-[#55654D]" : "bg-[#C86D51]/15 text-[#B35B40]"
                  }`}
                >
                  {open ? "Open now" : "Closed"}
                </span>
              </div>
              <ul className="mt-5 space-y-2.5">
                {orderedDays.map((d) => (
                  <li
                    key={d}
                    data-testid={`hours-row-${HOURS[d].day.toLowerCase()}`}
                    className={`flex items-center justify-between rounded-xl px-3 py-2 text-sm ${
                      d === today
                        ? "bg-[#C86D51]/10 font-semibold text-[#2C1D11]"
                        : "text-[#6E5E53]"
                    }`}
                  >
                    <span>{HOURS[d].day}{d === today ? " · today" : ""}</span>
                    <span className="font-accent">{HOURS[d].label}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="overflow-hidden rounded-3xl shadow-sm" data-testid="location-map">
            <iframe
              title="Nomad Cafe on the map"
              src={CAFE.mapEmbed}
              className="h-full min-h-[420px] w-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
};
